
import {getReplenishmentUser} from '../api/getReplenishmentUser';
import {setGetReplenishmentUserAction} from '../action';

const setGetReplenishmentUser = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getReplenishmentUser(params);
            
            if (data.status === 'success') {
                dispatch(setGetReplenishmentUserAction({
                    data: data.data,
                    count: data.count
                }));           
            }
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetReplenishmentUser
}